import React from "react";
import { NavLink } from "react-router-dom";

const Lnk = props => <NavLink className="link link--primary" to={props.here}>{props.children}</NavLink>;

export default React.memo(Lnk, (prevProps, nextProps) => {
    return prevProps.here == nextProps.here && prevProps.children === nextProps.children;
});